import { READINESS_CHECKLIST_CATEGORY } from '@/core/models/form.model'

/** Parse the comma-separated tags input into a trimmed, non-empty string array. */
export function parseTagsInput(raw: string): string[] {
  return raw
    .split(',')
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 0)
}

/**
 * Toggle the waiting-room readiness-checklist category on/off while preserving any OTHER categories
 * the template already carries. This category is what the waiting-room readiness dropdown filters on,
 * so a template must carry it to be selectable as a preparation checklist.
 */
export function withChecklistCategory(existing: string[] | undefined, isChecklist: boolean): string[] {
  const base = (existing ?? []).filter((category) => category !== READINESS_CHECKLIST_CATEGORY)
  return isChecklist ? [...base, READINESS_CHECKLIST_CATEGORY] : base
}
